import { BrandId } from '@delta-defense/delta-utils';

type BrandStyles = {
  className: string;
  linkColor: string;
  textColor: string;
  button: string
};

export const getStylesByBrand = (brandId: BrandId): BrandStyles | undefined => {
  const stylesMap: Record<BrandId, BrandStyles> = {
    [BrandId.CABELAS]: {
      className: 'cabelas-style',
      linkColor: '#121212',
      textColor: '#121212',
      button: 'btn'
    },
    [BrandId.USCCA]: {
      className: 'uscca-style',
      linkColor: '#fff',
      textColor: '#fff',
      button: 'btn-alt'
    }
  };

  return stylesMap[brandId];
};
